// @flex
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
    input: {
        width: '42%',
        display: 'inline-block',
        borderRight: '1px solid gray'
    }
});

type Props = $ReadOnly<{

}>;
function DoubleInput({ inputRef, value, className, onChange, onBlur, ...other }: Props) {
    const classes = useStyles();
    const [innerValue, setInnerValue] = useState(value);

    useEffect(() => {
        setInnerValue(value);
    }, [value]);

    const handleChange = (type) => (e) => {
        const newValue = {
            ...value,
            [type]: e.target.value
        };

        setInnerValue(newValue);

        if(onChange) {
            onChange({
                ...e,
                target: {
                    ...e.target,
                    value: newValue
                }
            });
        }
    };

    const handleBlur = (e) => {
        if(onBlur) {
            onBlur({
                ...e,
                target: {
                    ...e.target,
                    value: innerValue
                }
            });
        }
    };

    return (
        <span ref={inputRef}>
            <input
                {...other}
                className={classnames(className, classes.input)}
                value={value && typeof value.x !== 'undefined' ? value.x : ''}
                onChange={handleChange('x')}
                onBlur={handleBlur}
            />
            <input
                {...other}
                className={classnames(className, classes.input)}
                value={value && typeof value.y !== 'undefined' ? value.y : ''}
                onChange={handleChange('y')}
                onBlur={handleBlur}
            />
        </span>
    );
}

export default DoubleInput;